module.exports = __webpack_public_path__ + "img/V61.09fecf01.jpg";